import { render, staticRenderFns } from "./draggable_compat.vue.js?vue&type=template&id=4607834e!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./draggable_compat.vue?vue&type=template&id=4607834e"
import script from "./draggable_compat.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./draggable_compat.vue?vue&type=script&lang=js"
export * from "./draggable_compat.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./draggable_compat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4607834e')) {
      api.createRecord('4607834e', component.options)
    } else {
      api.reload('4607834e', component.options)
    }
    module.hot.accept("./draggable_compat.vue.js?vue&type=template&id=4607834e!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./draggable_compat.vue?vue&type=template&id=4607834e", function () {
      api.rerender('4607834e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "lib/utils/vue3compat/draggable_compat.vue"
export default component.exports